// vereinsansicht.ts — was eine Körperschaft zum VEREIN macht, und wann ein
// Mitglied unser eigener Kontakt ist.
//
// Rein und ohne React: Die Regeln werden in der Mitgliederliste gebraucht und
// sollen ohne gerenderte Oberfläche prüfbar sein.

/**
 * Ist diese Rechtsform ein Verein?
 *
 * Der Bestand führt mehrere Schreibweisen nebeneinander („Eingetragener Verein
 * (e.V.)", „Gemeinnütziger Verein (e.V.)", „Nicht eingetragener Verein"), und
 * es kommen laufend welche dazu. Deshalb wird auf das WORT geprüft und nicht
 * gegen eine Liste verglichen — eine Liste wäre schon beim nächsten
 * Katalogeintrag unvollständig, und der Fehler fiele niemandem auf: Die Seite
 * sähe nur weiter aus wie bei einer GmbH.
 */
export const istVereinsRechtsform = (rechtsform?: string | null): boolean => {
  const s = String(rechtsform ?? "").toLowerCase();
  if (!s.trim()) return false;
  return s.includes("verein") || /\be\.\s?v\.?\b/.test(s);
};

/**
 * Status, bei denen die Person ein Kontakt VON UNS ist — nicht nur jemand, den
 * wir über den Verein kennen.
 *
 * Das ist die Frage aus dem Gespräch: „ist es ein direkter Kontakt von uns oder
 * nur über den Verein bekannt". Sie entscheidet, wen man ansprechen darf.
 */
const DIREKTE_STATUS = new Set([
  "Kunde",
  "Interessent",
  "Altkunde",
  "Altinteressent",
  "Persönlicher Kontakt",
]);

/**
 * Ist diese Person ein direkter Kontakt?
 *
 * Ohne Status gilt sie als INDIREKT. Das ist die vorsichtige Antwort: Wer
 * unsicher ist, spricht niemanden an, den er nicht kennt — die Umkehrung würde
 * eine Beziehung behaupten, die es vielleicht nicht gibt.
 */
export const istDirekterKontakt = (status?: string | null): boolean =>
  DIREKTE_STATUS.has(String(status ?? "").trim());

/** Beschriftung der Mitgliederliste — beim Verein heißt sie anders. */
export const mitgliederUeberschrift = (istVerein: boolean): string =>
  istVerein ? "Mitglieder und Verantwortliche" : "Menschen im Unternehmen";

/** Leertext derselben Liste. */
export const mitgliederLeertext = (istVerein: boolean): string =>
  istVerein ? "Keine Mitglieder erfasst." : "Keine Personen im Unternehmen.";
